import { cadastro_de_informacao_complementar } from "./cadastro-de-informacao-complementar";
import { cadastro_de_detalhes_da_informacao_complementar } from "./cadastro-de-detalhe-da-informacao-complementar";
import { cadastro_de_informacao_complementar_do_aluno } from "./cadastro-de-informacao-complementar-do-aluno";
import { aluno_com_deficiencia } from "./aluno-com-deficiencia/index";
import { relacao_de_alunos_incluidos } from "./relacao-de-alunos-incluidos";
import { cadastro_de_transporte_escolar_por_turma } from "./cadastro-de-transporte-escolar-por-turma/index";
import { consulta_de_transporte_escolar_por_turma } from "./consulta-de-transporte-escolar-por-turma/index";
import { gerar_arquivo_de_transporte_escolar } from "./gerar-arquivo-de-transporte-escolar/index";
import { cadastro_de_transporte_escolar_por_aluno } from "./cadastro-de-transporte-escolar-por-aluno";

const informacao_complementar = [
  ...cadastro_de_informacao_complementar,
  cadastro_de_detalhes_da_informacao_complementar,
  ...cadastro_de_informacao_complementar_do_aluno,
  ...aluno_com_deficiencia,
  ...relacao_de_alunos_incluidos,
  ...cadastro_de_transporte_escolar_por_turma,
  ...consulta_de_transporte_escolar_por_turma,
  ...gerar_arquivo_de_transporte_escolar,
  ...cadastro_de_transporte_escolar_por_aluno,
];

export { informacao_complementar };
